import React from 'react'
import * as R from 'ramda'
import { useMessageTemplateManagementModal } from 'components/modals/MessageTemplateManagementModal/hooks'
import { useSelector } from 'react-redux'
import { getLocation } from 'ducks/router'
import { useSearch } from 'hooks'
import { fetchDepartments } from 'api/departments'
import { getDepartmentValueFromQuery } from 'components/pages/Jobs/helpers'

export const useFilter = () => {
  const { query } = useSelector(getLocation)

  const [filter, setFilter] = React.useState(
    R.isNil(query.department) ? null : { department: [query.department] },
  )
  const [departmentValue, setDepartmentValue] = React.useState([])

  const setDepartment = department => {
    setFilter({ department: department.map(dep => dep.value) })
    setDepartmentValue(department)
  }

  React.useEffect(async () => {
    const { response } = await fetchDepartments({})
    setDepartmentValue(getDepartmentValueFromQuery(query, response?.results))
  }, [])

  return {
    state: { filter, departmentValue },
    handlers: { setDepartment },
  }
}

export const useMessageTemplates = () => {
  const [template, setTemplate] = React.useState(null)

  const handleResetTemplate = React.useCallback(() => {
    setTemplate(null)
  }, [])

  const [search, setSearch] = useSearch()

  const {
    state: { filter, departmentValue },
    handlers: { setDepartment },
  } = useFilter()

  const {
    handleMessageTemplateManagementModalClose,
    handleMessageTemplateManagementModalConfirm,
    handleMessageTemplateManagementModalOpen,
    isMessageTemplateManagementModalOpen,
  } = useMessageTemplateManagementModal(
    { template },
    { onResetTemplate: handleResetTemplate },
  )

  const handleEdit = React.useCallback(
    ({ template }) => {
      setTemplate(template)
      handleMessageTemplateManagementModalOpen()
    },
    [handleMessageTemplateManagementModalOpen],
  )

  return {
    state: {
      search,
      template,
      isMessageTemplateManagementModalOpen,
      departmentValue,
      filter,
    },
    handlers: {
      handleMessageTemplateManagementModalClose,
      handleMessageTemplateManagementModalConfirm,
      setDepartment,
      handleEdit,
      setSearch,
    },
  }
}
